import styled from 'styled-components';

import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { RadioButtonLabel } from '@ad-scripts/presentation/components/common/radio_button';
import RadioGroup from 'src/presentation/components/forms/RadioGroup';
import { StepContainer } from 'src/presentation/components/pages/email/components/StepWizardLayout';

export const StyledBold = styled.span`
  font-weight: ${p => p.theme.fontWeight.heavy};
`;

export const StyledLink = styled.a`
  color: inherit;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const StyledDescription = styled.p`
  line-height: 20px;
  margin-bottom: 20px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  ${RadioButtonLabel} {
    font-weight: ${p => p.theme.fontWeight.heavy};
  }
`;

export const StepWizardActionContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: ${({ theme }) => theme.spacing.insetMedium};
  padding-top: ${({ theme }) => theme.spacing.insetLarge};
  padding: 0 ${({ theme }) => theme.spacing.insetLarge};
`;

export const StyledStepContainer = styled(StepContainer)`
  max-height: 300px;
  transition: 0.5s max-height 0.1s ease;
  ${p => p.isActive && `max-height : 100vh`}
`;

export const ModalContainer = styled(EmbedModalWithGreenHeader).attrs({
  modalSize: ModalSize.EXTRALARGE,
})``;
